import React from "react";

const Drugs = () => (
  <svg width="280px" height="280px" viewBox="0 0 280 280" version="1.1">
    <g
      id="Davos_Frame_09"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
      transform="translate(-236.000000, -400.000000)"
    >
      <g
        id="resistance-fighting-icon"
        transform="translate(237.000000, 401.000000)"
      >
        <g id="Pill-3" className="pill" stroke-linecap="round" stroke-width="2">
          <path
            transform="translate(16.529783, 224.905235)"
            d="M34.7125451,16.6299639 C38.4693141,12.8731949 38.4693141,6.76218412 34.7125451,3.00541516 C30.9557762,-0.751353791 24.8447653,-0.751353791 21.0879964,3.00541516 L12.0717509,12.0216606 L25.6962996,25.6462094 L34.7125451,16.6299639 Z"
            id="Shape"
            stroke="#00D5C1"
          />
          <path
            transform="translate(16.529783, 224.905235)"
            d="M12.0717509,12.0216606 L3.05550542,21.0379061 C-0.701263538,24.7946751 -0.701263538,30.9056859 3.05550542,34.6624549 C6.81227437,38.4192238 12.9232852,38.4192238 16.6800542,34.6624549 L25.6962996,25.6462094 L12.0717509,12.0216606 Z"
            id="Shape"
            stroke="#FFFFFF"
          />
        </g>
        <g id="Pill-2" className="pill" stroke-linecap="round" stroke-width="2">
          <path
            transform="translate(27.000000, 174.000000)"
            d="M16.5284296,2.86868231 C12.7716606,-0.888086643 6.66064982,-0.888086643 2.90388087,2.86868231 C-0.852888087,6.62545126 -0.852888087,12.7364621 2.90388087,16.493231 L11.9201264,25.5094765 L25.5446751,11.8849278 L16.5284296,2.86868231 Z"
            id="Shape"
            stroke="#FFFFFF"
          />
          <path
            transform="translate(27.000000, 174.000000)"
            d="M11.9201264,25.5094765 L20.9363718,34.525722 C24.6931408,38.282491 30.8041516,38.282491 34.5609206,34.525722 C38.3176895,30.7689531 38.3176895,24.6579422 34.5609206,20.9011733 L25.5446751,11.8849278 L11.9201264,25.5094765 Z"
            id="Shape"
            stroke="#00D5C1"
          />
        </g>
        <g id="Pill-1" className="pill" stroke-linecap="round" stroke-width="2">
          <path
            transform="translate(68.000000, 215.000000)"
            d="M10.4413357,0.788808664 C5.13176895,0.788808664 0.82400722,5.14666065 0.82400722,10.4061372 C0.82400722,15.715704 5.18185921,20.0234657 10.4413357,20.0234657 L23.2143502,20.0234657 L23.2143502,0.738718412 L10.4413357,0.738718412 L10.4413357,0.788808664 Z"
            id="Shape"
            stroke="#FFFFFF"
          />
          <path
            transform="translate(68.000000, 215.000000)"
            d="M23.2143502,20.0234657 L35.9873646,20.0234657 C41.2969314,20.0234657 45.6046931,15.6656137 45.6046931,10.4061372 C45.6046931,5.0965704 41.2468412,0.788808664 35.9873646,0.788808664 L23.2143502,0.788808664 L23.2143502,20.0234657 Z"
            id="Shape"
            stroke="#00D5C1"
          />
        </g>
        <g className="pill">
          <rect
            id="Rectangle-path"
            fill="#1A1C35"
            fill-rule="nonzero"
            transform="translate(139.984820, 140.008818) rotate(135.000000) translate(-139.984820, -140.008818) "
            x="109.505193"
            y="56.4841228"
            width="60.9592529"
            height="167.049391"
          />
          <path
            d="M149.519404,106.441787 C149.519404,118.363267 139.902076,127.980596 127.980596,127.980596 C116.059116,127.980596 106.441787,137.597924 106.441787,149.519404"
            id="Shape"
            stroke="#00D5C1"
            stroke-width="2"
            stroke-linecap="round"
          />
          <path
            d="M277.5,277.5 L240.884025,240.884025"
            id="Shape"
            stroke="#FFFFFF"
            stroke-width="2"
            stroke-linecap="round"
          />
          <g
            id="Lines"
            transform="translate(69.124549, 102.184116)"
            stroke-linecap="round"
            stroke-width="2"
          >
            <path
              d="M9.81768953,0.150270758 L0,10.0180505"
              id="Shape"
              stroke="#FFFFFF"
            />
            <path
              d="M12.6227437,10.5189531 L6.5618231,16.6299639"
              id="Shape"
              stroke="#FFFFFF"
            />
            <path
              d="M19.1845668,17.1308664 L13.1236462,23.191787"
              id="Shape"
              stroke="#FFFFFF"
            />
            <path
              d="M25.7964801,23.6926895 L19.7355596,29.7536101"
              id="Shape"
              stroke="#FFFFFF"
            />
            <path
              d="M32.3583032,30.2545126 L26.2973827,36.3655235"
              id="Shape"
              stroke="#FFFFFF"
            />
            <path
              d="M42.7269856,33.0595668 L32.8592058,42.9273466"
              id="Shape"
              stroke="#FFFFFF"
            />
            <path
              d="M45.5320397,43.4282491 L39.4711191,49.4891697"
              id="Shape"
              stroke="#00D5C1"
            />
            <path
              d="M52.0938628,50.0401625 L46.0329422,56.101083"
              id="Shape"
              stroke="#00D5C1"
            />
            <path
              d="M58.7057762,56.6019856 L52.5947653,62.6629061"
              id="Shape"
              stroke="#00D5C1"
            />
            <path
              d="M65.2675993,63.1638087 L59.2066787,69.2748195"
              id="Shape"
              stroke="#00D5C1"
            />
            <path
              d="M75.6362816,65.9688628 L65.7685018,75.8366426"
              id="Shape"
              stroke="#00D5C1"
            />
            <path
              d="M78.4413357,76.3375451 L72.3804152,82.3984657"
              id="Shape"
              stroke="#00D5C1"
            />
            <path
              d="M85.0031588,82.8993682 L78.9422383,89.0103791"
              id="Shape"
              stroke="#00D5C1"
            />
            <path
              d="M91.6150722,89.5112816 L85.5040614,95.5722022"
              id="Shape"
              stroke="#00D5C1"
            />
            <path
              d="M98.1768953,96.0731047 L92.1159747,102.134025"
              id="Shape"
              stroke="#00D5C1"
            />
            <path
              d="M108.545578,98.8781588 L98.6777978,108.745939"
              id="Shape"
              stroke="#00D5C1"
            />
          </g>
          <path
            d="M23.3420578,0 L0,23.3420578"
            id="Shape"
            stroke="#FFFFFF"
            stroke-width="2"
            stroke-linecap="round"
          />
          <polygon
            id="Shape"
            stroke="#FFFFFF"
            stroke-width="2"
            fill="#1A1C35"
            fill-rule="nonzero"
            stroke-linecap="round"
            stroke-linejoin="round"
            points="222.500903 204.21796 241.935921 223.602888 246.944946 234.823105 234.823105 246.944946 223.602888 241.935921 204.21796 222.500903"
          />
          <polygon
            id="Shape"
            stroke="#FFFFFF"
            stroke-width="2"
            fill="#1A1C35"
            fill-rule="nonzero"
            stroke-linecap="round"
            stroke-linejoin="round"
            points="220.647563 177.519856 222.500903 204.21796 204.21796 222.500903 177.519856 220.647563"
          />
          <rect
            id="Rectangle-path"
            stroke="#FFFFFF"
            stroke-width="1.99998082"
            fill="#1A1C35"
            fill-rule="nonzero"
            stroke-linecap="round"
            stroke-linejoin="round"
            transform="translate(77.066619, 77.043713) rotate(135.000000) translate(-77.066619, -77.043713) "
            x="59.3598843"
            y="71.5588824"
            width="35.413469"
            height="10.9696601"
          />
          <polygon
            id="Shape"
            stroke="#FFFFFF"
            stroke-width="2"
            fill="#1A1C35"
            fill-rule="nonzero"
            stroke-linecap="round"
            stroke-linejoin="round"
            points="59.6074007 70.2265343 6.36146209 16.9805957 16.9805957 6.36146209 70.2265343 59.6074007 85.7044224 60.7093863 60.7093863 85.7044224"
          />
          <path
            d="M49.3889892,112.502708 L112.502708,49.3889892"
            id="Shape"
            stroke="#FFFFFF"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <rect
            id="Rectangle-path"
            stroke="#FFFFFF"
            stroke-width="1.99998082"
            stroke-linecap="round"
            stroke-linejoin="round"
            transform="translate(139.984820, 140.008818) rotate(135.000000) translate(-139.984820, -140.008818) "
            x="109.505193"
            y="56.4841228"
            width="60.9592529"
            height="167.049391"
          />
        </g>
      </g>
    </g>
  </svg>
);

export default Drugs;



// WEBPACK FOOTER //
// ./src/components/tools/drugs.js